import { render, staticRenderFns } from "./ExpendInfo.vue?vue&type=template&id=c5f01d48&scoped=true&"
import script from "./ExpendInfo.vue?vue&type=script&lang=js&"
export * from "./ExpendInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f01d48",
  null
  
)

export default component.exports